import removeIcon from './Icons/RemoveIcon';
import fileIcon from './Icons/FileIcon';

export const RemoveIcon = removeIcon;
export const FileIcon = fileIcon;
